import generatedManifest from '$lib/generated/aqueductExampleSnapshotManifest.json';
import { SITE_ORIGIN } from '$lib/siteConfig';
import type { SnapshotMeta } from './snapshotMeta';

export type ExampleSnapshot = {
	id: string;
	displayName: string;
	documentUrl: string;
	/** 256 px. */
	thumbnailUrl: string;
	/** 512 px, for 2x displays. */
	thumbnail2xUrl: string;
	captureResolution: number;
};

type ExampleSnapshotManifest = {
	version: number;
	examples: Record<string, ExampleSnapshot>;
};

const manifest = generatedManifest as ExampleSnapshotManifest;

export function listExampleSnapshots(): ExampleSnapshot[] {
	return Object.values(manifest.examples);
}

export function getExampleSnapshot(id: string): ExampleSnapshot | undefined {
	return manifest.examples[id];
}

export function requireExampleSnapshot(id: string): ExampleSnapshot {
	const example = getExampleSnapshot(id);
	if (!example) throw new Error(`Unknown bundled example snapshot: ${id}`);
	return example;
}

/** `srcset` for an example thumbnail shown at 256 CSS pixels or less. */
export function exampleThumbnailSrcset(example: ExampleSnapshot): string {
	return `${example.thumbnailUrl} 1x, ${example.thumbnail2xUrl} 2x`;
}

export function exampleSnapshotMeta(example: ExampleSnapshot): SnapshotMeta {
	return {
		name: example.displayName,
		thumbnail_url: `${SITE_ORIGIN}${example.thumbnailUrl}`
	};
}

export const LANDING_EDITOR_EXAMPLE = requireExampleSnapshot('lava-002');
export const MARBLE_003_EXAMPLE = requireExampleSnapshot('marble-003');
export const WOOD_GRAIN_EXAMPLE = requireExampleSnapshot('wood-grain');
export const CLIFF_ROCK_001_EXAMPLE = requireExampleSnapshot('cliff-rock-001');
export const TERRACOTTA_001_EXAMPLE = requireExampleSnapshot('terracotta-001');
export const LEATHER_002_EXAMPLE = requireExampleSnapshot('leather-002');
export const CRACKED_ICE_EXAMPLE = requireExampleSnapshot('cracked-ice');
export const STYLIZED_LIMESTONE_EXAMPLE = requireExampleSnapshot('stylized-limestone');
export const STYLIZED_GRASS_EXAMPLE = requireExampleSnapshot('stylized-grass');
